export default {
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/notifications", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/notifications/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/notifications/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
